<template>
	<div>
		<div>
			<SalaryEdit
				v-model="hourlyRate"
				:inline="false"
				placeholder-non-range="zB: 25"
				@input="emitChangeEvent"
			>
				<template #input-info>
					<div>Dein Mindeststundensatz - <b>Brutto</b> vor Abzug der Steuern.</div>
				</template>
			</SalaryEdit>
		</div>
		<InfoBox class="mt-4">
			Dein genauer Stundensatz wird ArbeitgeberInnen nicht angezeigt, sondern dient nur dem Matching bzw.
			dem Ermitteln, ob ein Job passt.
		</InfoBox>
	</div>
</template>

<script>
import SalaryEdit from "@/vue/common/salary/Edit";
import {isDefined} from "@/helper/Value";
import InfoBox from "@/vue/common/InfoBox.vue";

export default {

	components: {
		InfoBox,
		SalaryEdit,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		let hourlyRate = null;

		if (this.value?.hourlyRate)
		{
			hourlyRate = {
				salary: this.value.hourlyRate
			};
		}

		return {
			hourlyRate,
		};
	},

	computed: {
		dataValid ()
		{
			return isDefined(this.hourlyRate);
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				hourlyRate: this.hourlyRate.salary
			});
		},
	},
}
</script>
